import { token } from '@atlaskit/tokens';
import { type DatabaseFieldType } from '@databases/types/database';
import { getNumberDisplayString } from '@databases/utils/database/field-types/number';
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';
import styled from 'styled-components';

import { type ViewComponentProps } from './types.ts';

const FormattedNumber = styled.div<{
  showDisabledValue?: boolean;
}>`
  text-align: var(--database-number-field-text-align, right);
  color: ${({ showDisabledValue }) =>
    showDisabledValue ? token('color.text.disabled', '#8993A4') : 'inherit'};
`;

const NumberValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.NUMBER>
> = ({ field, value, showDisabledValue }) => {
  const { locale } = useIntl();

  const formatted = value !== '' ? getNumberDisplayString(value, field, locale) : '';

  return (
    <FormattedNumber showDisabledValue={showDisabledValue}>{formatted}</FormattedNumber>
  );
};

export default NumberValueView;
